import { useState, useEffect } from 'react';
import useCookie from 'react-use-cookie';


export default function useJsonCookie(key, initialValue) {

    var separate = window.location.hostname.split('.');
    separate.shift();
    var currentdomain = separate.join('.');
    let cookieSettings = {
        SameSite: 'Lax',
        days: 365,
        domain: "."+currentdomain
    };
    
    const [valueer, setter, removeStartDate] = useCookie(key, JSON.stringify(initialValue));
    var wrappedSetter = (x) => {
        setter(JSON.stringify(x), cookieSettings);
    }
    var unwrappedValue = JSON.parse(valueer);
    return [unwrappedValue, wrappedSetter, removeStartDate];
}
